import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion'
import { Text, Link } from 'theme-ui'

const styles = {
  listItem: {
    pb: `10px`
  }
}

const accordion = ({ items, setOpen, name }) => {
  const preExpandedCode = name === 'Digital Collections' ? 'ex-y' : 'ex-n';
  return (
    <Accordion
      className='border-none'
      allowZeroExpanded
      preExpanded={[preExpandedCode]}
    >
      <AccordionItem uuid={`ex-y`}>
        <AccordionItemHeading>
          <AccordionItemButton className='accordion__button'>
            {name}
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          {items.map((item, i) => {
            return (
              <>
                <Link href={item.slug} onClick={() => setOpen(false)}>
                  <Text sx={styles.listItem}>{item.name}</Text>
                </Link>
              </>
            )
          })}
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default accordion
